import { render, staticRenderFns } from "./VideoTile.vue?vue&type=template&id=a2e3a6dc&scoped=true&"
import script from "./VideoTile.vue?vue&type=script&lang=ts&"
export * from "./VideoTile.vue?vue&type=script&lang=ts&"
import style0 from "./VideoTile.vue?vue&type=style&index=0&id=a2e3a6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e3a6dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
